module.exports = __webpack_public_path__ + "img/20220112_103405.16b866ed.jpg";